import { Component, ojs, app, payload } from "modular-openscriptjs";
import { eParse } from "../helpers";
import Swal from "sweetalert2";

const broker = app("broker");

export default class Confirmation extends Component {
	alert;

	constructor() {
		super();
		/**
		 * Configure Sweet Alert here
		 */
		this.alert = Swal?.mixin({});
	}

	$$system = {
		needs: {
			approval: (ed, event) => this.requestApproval(ed, event),
		},
		has: {
			confirmation: (ed, event) => this.showConfirmation(ed, event),
		},
	};

	render(...args) {
		return app("h").div(
			...args
		);
	}

	async showConfirmation(ed, __event) {
		if (!ed) ed = payload();

		let { message } = eParse(ed);

		const title = message?.title ?? "Confirmation";
		const text = message?.message ?? "";
		const type = message?.type ?? "success";
		const closeText = message?.close_text ?? "OK";
		const action = message?.action ?? {};
		const routeName = action?.route_name;
		const routeParams = action?.route_params ?? {};

		this.alert = Swal?.mixin({});

		this.alert
			?.fire({
				title: title,
				text: text,
				icon: type,
				confirmButtonText: closeText,
				showCancelButton: false,
			})
			.then((result) => {
				if (result.isConfirmed && routeName) {
					const route = app("router");
					route.to(routeName, routeParams);
				}
			});
	}

	async requestApproval(ed, __event) {
		if (!ed) ed = payload();

		let { meta, message } = eParse(ed);

		if (!meta.has("__event")) {
			console.error("No Returning event found for payload", ed);
			return;
		}

		this.alert = Swal?.mixin({});

		this.alert
			?.fire({
				title: "Are you sure?",
				text: meta.get("__ct", ""),
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Yes, please!",
				cancelButtonText: "No, cancel!",
				reverseButtons: true,
			})
			.then((result) => {
				if (result.isConfirmed) {
					meta.put("__confirmed", true);
					return broker.send(
						meta.get("__event"),
						payload(message, meta)
					);
				}

				meta.put("__confirmed", false);
				return broker.send(meta.get("__event"), payload(message, meta));
			});
	}
}

ojs(Confirmation);
